import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28554f5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jobs-cookie-info" }
const _hoisted_2 = { class: "jobs-cookie-info__content" }
const _hoisted_3 = { class: "jobs-cookie-info__content-heading" }
const _hoisted_4 = { class: "jobs-cookie-info__content-subline" }
const _hoisted_5 = {
  class: "jobs-cookie-info__content-cancel",
  href: "/"
}

import { EButtonMode } from '../../common/enums/button.enum';
  import CustomButton from './CustomButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'JobsCookieInfo',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.$translationsUfeNamespace}jobs.cookie.headline`)), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.$translationsUfeNamespace}jobs.cookie.subline`)), 1),
      _createVNode(CustomButton, {
        class: "jobs-cookie-info__content-button",
        mode: _unref(EButtonMode).PRIMARY,
        text: _ctx.$t(`${_ctx.$translationsUfeNamespace}jobs.cookie.adjust`),
        "onClick:button": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:cookies`)))
      }, null, 8, ["mode", "text"]),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.$translationsUfeNamespace}jobs.cookie.cancel`)), 1)
    ])
  ]))
}
}

})